import React from 'react'
import PropTypes from 'prop-types'

import TableDataLoader from '../../../../../components/Table/TableDataLoader'
import RequestedFilesTableData from './RequestedFilesTableData'

import { RequestedFilesProvider } from './RequestedFilesTableData/RequestedFilesContext'

import {
  getMediaOrderRequestedFilesErrorSelector,
  getMediaOrderRequestedFilesIsLoadingSelector,
  getMediaOrderRequestedFilesWasLoadedSelector
} from '../../../../../modules/selectors/mediaOrdersBookings'
import { requestedFilesColumnsSchema } from './const/columns'

const RequestedFilesTable = ({ files, bookedMediaId }) => {
  return (
    <RequestedFilesProvider>
      <TableDataLoader
        itemsLength={files.length}
        errorSelector={getMediaOrderRequestedFilesErrorSelector}
        wasLoadedSelector={getMediaOrderRequestedFilesWasLoadedSelector}
        isLoadingSelector={getMediaOrderRequestedFilesIsLoadingSelector}
        skeletonProps={{ cols: requestedFilesColumnsSchema }}
        noDataContent={<div />}
      >
        <RequestedFilesTableData files={files} bookedMediaId={bookedMediaId} />
      </TableDataLoader>
    </RequestedFilesProvider>
  )
}

RequestedFilesTable.propTypes = {
  files: PropTypes.array.isRequired,
  bookedMediaId: PropTypes.number.isRequired
}

export default RequestedFilesTable
